
<template>
	<div id="list-events">
		<h1>Eventos</h1>
		<b-list-group>
			<b-list-group-item
				class="d-flex justify-content-between align-items-center"
				v-for="(event,index) in eventsList"
				:key="index"
			>
				<b-container>
					<b-row>
						<b-col lg="8">{{event.title}}</b-col>
						<b-col>
							<div class="mt-3">
								<b-button-group>
									<b-button variant="info" @click="flipViewFlags(index)">Ver</b-button>
									<b-button variant="info" @click="flipEditFlag(index,event)">Alterar</b-button>
									<b-button variant="info" @click="$bvModal.show('my-modal-event'+event.id)">Remover</b-button>
                  <b-modal :id="'my-modal-event'+event.id" title="Apagar Evento" @ok="deleteEvent(event.id)">Apagar {{event.title}} ?</b-modal>
								</b-button-group>
							</div>
						</b-col>
					</b-row>
					<b-row lg="10">
						<b-col>
							<div v-if="viewingFlags[index]">
                <form-event editingMode="view" :event="event"></form-event>
							</div>
							<div v-if="editingFlag - 1 == index">
                <form-event editingMode="edit" :event="event"></form-event>
							</div>
						</b-col>
					</b-row>
				</b-container>
			</b-list-group-item>
		</b-list-group>
	</div>
</template>

<script>
import api from "../../api";
import { jsonIn } from "../../utils/snakeCamel"
import formEvent from './formEvent'
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "listEvents",
  components:{formEvent},
	data() {
		return {
			viewingFlags: [],
			editingFlag: 0
		};
	},
	mounted() {
		this.refreshData();
  },
  computed:{
    ...mapGetters(['eventsList'])
  },
	methods: {
    ...mapActions(['refreshEvents']),
    deleteEvent(index){
      api.deleteEvent({id: index}).then(() =>
      this.refreshData()
      )
    },
		refreshData() {
    this.refreshEvents().then(() => {
      for (var i = 0; i < this.eventsList.length; i++) {
        this.viewingFlags[i] = false;
      }
    })
		},
		flipViewFlags: function(index) {
			if (index + 1 !== this.editingFlag) {
      this.$set(this.viewingFlags, index, !this.viewingFlags[index]);
      }
		},
		flipEditFlag: function(index, tour) {
			if (index + 1 !== this.editingFlag) {
				this.viewingFlags[index] = false;
				this.editingFlag = index + 1;
			} else {
				this.editingFlag = 0;
			}
		}
	}
};
</script>
<style script="css">
#list-events {
	text-align: left;
}
</style>

